/**
 * Client-side navigation target for a notification row.
 *
 * The backend `notifications` table has NO `link` column (schema.sql:4358-4377);
 * the SPA derives the route from the stored `envId` + `type` (notification.ts).
 * This keeps deep-links a pure function of backend-real fields — never a
 * persisted frontend route.
 *
 * Mapping rationale (type → most relevant destination):
 *  - `error`   → the failing env's detail (operational triage), else Environments.
 *  - `warning` → governance surface when org-wide (expiring grants, dormancy),
 *                else the env's detail.
 *  - others    → the env's detail when env-scoped, else the dashboard.
 */
import type { NotificationType } from '@/domain'

export function notificationTarget(
  envId: string | null | undefined,
  type: NotificationType,
): string {
  if (envId) return `/envs/${envId}`
  if (type === 'error' || type === 'warning') return '/access-requests'
  return '/dashboard'
}
